import { updateLazy } from 'Functions/lazy';
import { scrollToEl } from 'Functions/window';
import { initAnchors } from 'Functions/anchor';
import Swiper, { Pagination, Navigation } from 'swiper';

import 'Layouts/default';

import 'Ui/slider';
import 'Ui/shorten'
import 'Ui/more-items';
import 'Ui/tabs';
import 'Ui/slider';

import 'Common/paginator'

import './catalog-jquery';
import './filter-slider';
import './categories-filter';
import './price-filter';
import './multiselect';
import './filter-bubbles';

Swiper.use([Pagination, Navigation]);

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-listing-main__content'), 0)
        })
    }
}

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    attachPaginatorEvents()
    initAnchors()

    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing.products').first().find('.products__item').length);
    }
})

document.addEventListener('DOMContentLoaded', function() {
    attachPaginatorEvents();
    initAnchors()
});